import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";
import {
  ActiveInactiveSector,
  deleteSector,
  getAllSectors,
} from "./services/sector.services";
import { clearSectorDetails, clearSectorID, setSectorID } from "./sectorSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";

const Sector: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllSectors());
    return () => {
      dispatch(clearSectorDetails());
      dispatch(closeDialog());
    };
  }, []);

  const handleCreate = () => {
    navigate("/sector/create");
  };

  return (
    <>
      <DeleteSectorDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Sector List
          </Typography.h4>
          {/* {isAddAccess && (
            <ButtonCreate label="Add New" drawerName="sectorForm" />
          )} */}
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New Sector"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <SectorGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const SectorGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const loading = useAppSelector((state) => state.sector.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? SectorList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (ID: number) => {
      navigate("/sector/edit", { state: { SectorID: ID } });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(setSectorID(ID));
      dispatch(openDialog("deleteSector"));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {/* {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.ID}
            drawerName="sectorForm"
            tooltipTitle="Edit"
          />
        )} */}
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => handleEdit(props.dataItem.ID)}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveSector(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllSectors());
        } else {
          dispatch(getAllSectors());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {SectorList && SectorList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(SectorList, filter).slice(
                  page.skip,
                  page.take + page.skip,
                )
              : SectorList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={SectorList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="SequenceNo"
            title="Seq. No."
            width={90}
            filterable={false}
          />
          <Column
            field="SectorName"
            title="Sector"
            cells={{
              data: (props: any) => (
                // <td
                //   className={`${isEditAccess ? "hoverableName" : "normalName"}`}
                // >
                //   {isEditAccess ? (
                //     <LinkEdit
                //       ID={props.dataItem.ID}
                //       drawerName="sectorForm"
                //       label={props.dataItem?.SectorName}
                //     />
                //   ) : (
                //     props.dataItem?.SectorName
                //   )}
                // </td>
                <td>
                  {isEditAccess ? (
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/sector/edit", {
                          state: { SectorID: props.dataItem?.ID },
                        })
                      }
                    >
                      {props.dataItem?.SectorName}
                    </div>
                  ) : (
                    <div className="normalName">
                      {props.dataItem?.SectorName}
                    </div>
                  )}
                </td>
              ),
            }}
          />
          <Column field="SectorType" title="Sector Type" />
          <Column
            field="ID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteSectorDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SectorID = useAppSelector((state) => state.sector.SectorID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteSector(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllSectors());
        dispatch(closeDialog());
        dispatch(clearSectorID());
      } else {
        dispatch(getAllSectors());
        dispatch(closeDialog());
        dispatch(clearSectorID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteSector" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Sector"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Sector?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(SectorID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};
export default Sector;
